import { useState } from 'react';

import AttributeValue from '../attributes/AttributeValue';
import classes from './Collection.module.css';
import Image from './Image';

function Collection(props) {
	const [openInfo, setOpenInfo] = useState(true);

	return (
		<li className={classes.container} >
			{props.step >= props.maavStep &&
			<section>
				<div className={classes.label}>
					<h3 className={classes.attrName}>{props.attrName}
						{(props.maavInfo !== null) &&
							<span className={classes.hover_help}>
								<span className={classes.in_circle} onClick={() => setOpenInfo(true)}>?</span>
								{openInfo &&
									<span className={classes.infographic}>
										<span className={classes.close + " fa fa-times"} onClick={() => setOpenInfo(false)}></span>
										<Image
											key={props.maavStep}
											id={props.maavStep}
											name={"maav-infographic"}
											filename={props.maavInfo.filename}
											filetype={props.maavInfo.filetype}
											filename_webp={props.maavInfo.filename_webp}
										/>
									</span>
								}
							</span>
						}
					</h3>
				</div>
				<ul className={classes.list}>
					{props.values.map((attributevalue) => (
						<AttributeValue
							key={attributevalue.id}
							id={attributevalue.id}
							valueId={attributevalue.value}
							isImage={attributevalue.isImage}
							attrMedia={attributevalue.media}
							price={attributevalue.price}
							basePrice={attributevalue.basePrice}
							pricePreview={props.pricePreview}
							showStartingAt={attributevalue.showStartingAt}
							quantity={attributevalue.quantity}
							isSellableWhen0={attributevalue.isSellableWhen0}
							attrId={props.attrId}
							attrName={props.name}
							attrStyle={props.attributeStyles_id}
							maavStep={props.maavStep}
							filter={props.filter}
							selected={props.selected}
						/>
					))}
				</ul>
				{(props.maavMedia !== null && props.step === props.maavStep) &&
				<div>
					<Image
						key={props.maavStep}
						id={props.maavStep}
						name={"maav-banner"}
						filename={props.maavMedia.filename}
						filetype={props.maavMedia.filetype}
						filename_webp={props.maavMedia.filename_webp}
					/>
				</div> }
				<div className={"clearfix"}></div>
			</section>
			}
		</li>
	);
}

export default Collection;